export const BNPL_AVAILABLE =
  'Buy Now, Pay Later available for $50-$4,000 bookings.';
export const BNPL_AVAILABLE_DESCRIPTION =
  'Get approved before your appointment.';
export const LEARN_MORE_LINK = 'Sign up';
export const BNPL_MOBILE_AVAILABLE = 'Buy Now, Pay Later';
export const BNPL_MOBILE_AVAILABLE_DESCRIPTION = 'available in-person';
export const CLOSE_BUTTON_LABEL = 'Dismiss banner';
